//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';
import { hasFeatureVibePayments } from '@redux/selectors/getIsVibePaymentsEnabled';

import { componentNameToTemplate } from 'app/initialization/routing/stateHelpers';

export const creatorsStates = {
  'campaigns.creators': CampaignsStateFactory({
    url: '/creators?:chartMetric&:startDate&:endDate',
    data: {
      title: 'Campaigns: Social Creators',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsOverviewPage'),
      },
    },
  }),
  'campaigns.creators-request-details': CampaignsStateFactory({
    url: '/creators/requests/:requestId',
    redirectTo: 'campaigns.creators-request-summary',
  }),

  'campaigns.creators-request-basics': CampaignsStateFactory({
    url: '/creators/requests/:requestId/basics',
    data: {
      title: 'Campaigns: Social Creators Request Basics',
    },
    views: {
      main: {
        template: componentNameToTemplate('creatorsCampaignRequestDetailsPage'),
      },
    },
  }),

  'campaigns.creators-request-products': CampaignsStateFactory({
    url: '/creators/requests/:requestId/products',
    data: {
      title: 'Campaigns: Social Creators Request Products',
    },
    views: {
      main: {
        template: componentNameToTemplate('creatorsCampaignRequestDetailsPage'),
      },
    },
  }),

  'campaigns.creators-request-audience': CampaignsStateFactory({
    url: '/creators/requests/:requestId/audience',
    data: {
      title: 'Campaigns: Social Creators Request Audience',
    },
    views: {
      main: {
        template: componentNameToTemplate('creatorsCampaignRequestDetailsPage'),
      },
    },
  }),

  'campaigns.creators-request-tasks': CampaignsStateFactory({
    url: '/creators/requests/:requestId/tasks',
    data: {
      title: 'Campaigns: Social Creators Request Tasks',
    },
    views: {
      main: {
        template: componentNameToTemplate('creatorsCampaignRequestDetailsPage'),
      },
    },
  }),

  'campaigns.creators-request-summary': CampaignsStateFactory({
    url: '/creators/requests/:requestId/summary',
    data: {
      title: 'Campaigns: Social Creators Request Summary',
    },
    views: {
      main: {
        template: componentNameToTemplate('creatorsCampaignRequestDetailsPage'),
      },
    },
  }),

  'campaigns.creators-details': CampaignsStateFactory({
    url: '/creators/:campaignSlugName?:fromReportId',
    data: {
      title: 'Campaigns: Social Creators Details',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage?:fromReportId',
    data: {
      title: 'Campaigns: Social Creators Manage',
    },
    redirectTo: 'campaigns.creators-manage-creators',
  }),

  'campaigns.creators-configuration': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-configuration-manage': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration',
    },
    redirectTo: 'campaigns.creators-configuration-manage-basics',
  }),

  'campaigns.creators-configuration-manage-basics': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit/basics',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration Basics',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsConfigurationPage'),
      },
    },
  }),

  'campaigns.creators-configuration-manage-tasks': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit/tasks',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration Tasks',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsConfigurationPage'),
      },
    },
  }),

  'campaigns.creators-configuration-manage-products': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit/products',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration Products',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsConfigurationPage'),
      },
    },
  }),

  'campaigns.creators-configuration-manage-payment': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit/payment',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration Payment',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsConfigurationPage'),
      },
    },
  }),

  'campaigns.creators-configuration-manage-content-rights':
    CampaignsStateFactory({
      url: '/creators/:campaignSlugName/configuration/edit/content-rights',
      data: {
        title: 'Campaigns: Social Creator Manage Configuration Content Rights',
      },
      views: {
        main: {
          template: componentNameToTemplate(
            'campaignsCreatorsConfigurationPage',
          ),
        },
      },
    }),

  'campaigns.creators-configuration-manage-summary': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/configuration/edit/summary',
    data: {
      title: 'Campaigns: Social Creator Manage Configuration Summary',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsConfigurationPage'),
      },
    },
  }),

  'campaigns.creators-manage-creators': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/creators?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Creators',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-proposals': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/proposals?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Proposals',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-orders': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/orders?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Orders',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-orders-details': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/orders/:orderId/:creatorUsername?:network',
    data: {
      title: 'Campaigns: Social Creator Manage Orders Details',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsOrderDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-messages': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/messages?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Messages',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-messages-new-email': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/messages/new-email?:source',
    data: {
      title: 'Campaigns: Social Creator Manage Messages - New Email',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-messages-conversation': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/messages/:conversationId',
    data: {
      title: 'Campaigns: Social Creator Manage Messages Conversation',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-contents': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/contents?:fromReportId',
    data: {
      title: 'Campaigns: Social Creators Content',
    },
    redirectTo: 'campaigns.creators-contents-social-contents-media',
  }),

  'campaigns.creators-contents-social-contents': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/contents/social-contents?:fromReportId',
    data: {
      title: 'Campaigns: Social Creators Content',
    },
    redirectTo: 'campaigns.creators-contents-social-contents-media',
  }),

  'campaigns.creators-content-approval': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/contents/content-review?:view&:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Content Review',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-contents-social-contents-media': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/contents/social-contents/media?:view&:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Social Content',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-contents-social-contents-media-sparkcode-request':
    CampaignsStateFactory({
      url: '/creators/:campaignSlugName/contents/social-contents/media/:itemType/:itemId/sparkcode-request',
      data: {
        title: 'Campaigns: Social Creator Social Content Spark Code Request',
      },
      views: {
        main: {
          template: componentNameToTemplate(
            'campaignCreatorsRequestSparkCodePage',
          ),
        },
      },
    }),

  'campaigns.creators-contents-social-contents-media-apply-sparkcode':
    CampaignsStateFactory({
      url: '/creators/:campaignSlugName/contents/social-contents/media/:itemType/:itemId/:sparkCode/apply-sparkcode',
      data: {
        title: 'Campaigns: Social Creator Social Content Apply Spark Code',
      },
      views: {
        main: {
          template: componentNameToTemplate(
            'campaignCreatorsApplySparkCodePage',
          ),
        },
      },
    }),

  'campaigns.creators-contents-social-contents-sentiments':
    CampaignsStateFactory({
      url: '/creators/:campaignSlugName/contents/social-contents/sentiments?:fromReportId',
      data: {
        title: 'Campaigns: Social Creator Social Content Sentiments',
      },
      views: {
        main: {
          template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
        },
      },
    }),

  'campaigns.creators-creator': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/:creatorUsername?:network',
    redirectTo: 'campaigns.creators-creator-details',
  }),

  'campaigns.creators-creator-details': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/:creatorUsername/details?:network',
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsCreatorsCreatorDetailsPage',
        ),
      },
    },
  }),

  'campaigns.creators-creator-notes': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/:creatorUsername/notes?:network',
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsCreatorsCreatorDetailsPage',
        ),
      },
    },
  }),

  'campaigns.creators-proposal-details': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/proposals/:creatorUsername?:network',
    data: {
      title: 'Campaigns: Social Creator Proposals Details',
    },
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsCreatorsProposalDetailsPage',
        ),
      },
    },
  }),

  'campaigns.creators-manage-affiliates': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/affiliates?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Affiliates',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-affiliate-orders': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/affiliates/:creatorUsername/:affiliateCode/orders?:network',
    data: {
      title: 'Campaigns: Social Creator Manage Affiliate Orders',
    },
    views: {
      main: {
        template: componentNameToTemplate(
          'creatorsCampaignAffiliateOrdersDetailsPage',
        ),
      },
    },
  }),

  'campaigns.creators-manage-payments': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/payments?:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Payments',
      hasAccess: hasFeatureVibePayments,
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),

  'campaigns.creators-manage-payments-history': CampaignsStateFactory({
    url: '/creators/:campaignSlugName/manage/payments-history?creatorUsername&network&:fromReportId',
    data: {
      title: 'Campaigns: Social Creator Manage Payments History',
      hasAccess: hasFeatureVibePayments,
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsCreatorsDetailsPage'),
      },
    },
  }),
};
